import axios from 'axios'
import ActionsLogin from './LoginActions'

const config = {
  headers: {
    Authorization: 'Bearer ' + ActionsLogin.getToken()
  }
}

const gravarHistorico = ({
  cd_motorista,
  observacao,
  cd_status_motorista,
  cd_motivo_pendencia
}) => {
  return axios.post(
    process.env.URL_API_BASE + '/motorista-historico',
    {
      cd_motorista: cd_motorista,
      observacao: observacao,
      cd_status_motorista: cd_status_motorista,
      cd_motivo_pendencia: cd_motivo_pendencia,
      created_by: ActionsLogin.getUsuario().cd_usuario
    },
    config
  )
}

const listarHistoricoPorMotorista = async cdMotorista => {
  let response = await axios.get(
    process.env.URL_API_BASE +
      '/motorista-historico/listar-por-motorista/' +
      cdMotorista,
    config
  )
  return response.data
}

const obterHistorico = async id => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/motorista-historico/' + id,
    config
  )
  return response.data
}

export default {
  gravarHistorico,
  listarHistoricoPorMotorista,
  obterHistorico
}



// WEBPACK FOOTER //
// ./src/actions/MotoristaHistoricoActions.js